/* eslint-disable max-len */
import React from 'react';
import ReactGA from 'react-ga';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { connect } from 'react-redux';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import TagManager from 'react-gtm-module';
import { BlipChat } from 'blip-chat-widget';

import Loading from '../components/elements/Loading';

import AnalyticsService from '../app/services/analytics';

import Content from './Content';
import tagManager from '../app/services/tagManager';
import { initWindowResizeListeners } from '../components/utils';

export const history = createBrowserHistory();

const RctSwal = withReactContent(Swal);

initWindowResizeListeners();

history.listen((location) => {
  tagManager.contentView(window.location.href);
  if (window.analyticsEnable) AnalyticsService.sendPage(location.pathname);
  else if (window.gaEnable) ReactGA.pageview(location.pathname);
});

let gtmId = null;

export const initTagManager = (dataLayer) => {
  const tagManagerArgs = {
    gtmId,
    dataLayer,
  };

  TagManager.initialize(tagManagerArgs);
};

class AppRouter extends React.PureComponent {
  componentDidMount = () => {
    const {/*  popupBody, popupEnabled, */ tagManagerId } = this.props;
    // if (popupBody && popupBody.trim() && popupEnabled && popupEnabled.trim() === 'true') this.showAlert(popupBody);
    if (tagManagerId) setTimeout(() => tagManager.contentView(window.location.href), 1000);
  }

  componentDidUpdate = () => {
    const { popupBody, popupEnabled } = this.props;
    if (popupBody && popupBody.trim() && popupEnabled && popupEnabled.trim() === 'true') this.showAlert(popupBody);
  }

  showHuggy = (huggy) => {
    const huggyParams = JSON.parse(huggy);

    const script = document.createElement('script');
    script.innerHTML = (
      `var $_Huggy = { 
        defaultCountry: '${huggyParams.default_country}', 
        widget_id: '${huggyParams.widget_id}', 
        company: '${huggyParams.company}' 
      }; 
      
      (function(i,s,o,g,r,a,m){ 
        i[r]={
          context:{id:'${huggyParams.context_id}'}
        };
        a=o;
        o=s.createElement(o); 
        o.async=1;
        o.src=g;
        m=s.getElementsByTagName(a)[0];
        m.parentNode.insertBefore(o,m);
      })
      
      (window,document,'script','https://js.huggy.chat/widget.min.js','pwz');`
    );

    document.body.appendChild(script);
  }

  showBlipChat = (blipChatKey) => {
    new BlipChat()
      .withAppKey(blipChatKey)
      .withButton({ color: '#2CC3D5' })
      .build();
  }

  showZendesk = (zendesk) => {
    const script = document.createElement('script');
    script.src = zendesk;
    script.id = 'ze-snippet';
    script.async = true;
    document.body.appendChild(script);
  }

  showAlert = (popupBody = '', blocked = false) => {
    setTimeout(() => {
      RctSwal.fire({
        html: popupBody,
        width: 'auto',
        padding: '30px 40px 10px 40px',
        showConfirmButton: !blocked,
        allowOutsideClick: !blocked,
        allowEscapeKey: !blocked,
      });
    }, 1500);
  }

  render() {
    const {
      zendesk, huggy, tagManagerId, blipChatKey,
    } = this.props;

    gtmId = tagManagerId;

    return (
      <Router history={history}>
        <div className="page-wrapper">
          {tagManagerId && initTagManager()}
          {zendesk && this.showZendesk(zendesk)}
          {huggy && this.showHuggy(huggy)}
          {blipChatKey && this.showBlipChat(blipChatKey)}
          <Loading />
          <Content />
        </div>
      </Router>
    );
  }
}

const mapStateToProps = state => ({
  tagManagerId: state.settings.tagManagerId,
  zendesk: state.settings.zendeskUrlWeb,
  huggy: state.settings.huggyParams,
  popupBody: state.settings.popupBody,
  popupEnabled: state.settings.popupEnabled,
  blipChatKey: state.settings.blipChatKey,
  isPunchOut: !!state.punchOut,
});

export default connect(mapStateToProps)(AppRouter);
